import React from 'react'
import HotelViewPage from '../sections/Hotel/view/hotel-view'

function HotelPage() {
  return (
   <>
   <HotelViewPage/>
   </>
  )
}

export default HotelPage